var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelAd14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.613 3c.85 0 1.537 1.788 1.537 3.993s-.688 3.994-1.537 3.994c-.353 0-.679-.31-.939-.832l-.015.012c-.91-1.188-2.28-1.599-3.27-1.734l.468 1.743a.62.62 0 0 1-.349.726l-.097.034a.624.624 0 0 1-.765-.436l-.57-2.125-.038-.001c-.5-.06-.888-.482-.888-1V6.69c0-.553.44-1 .993-1.028 0 0 2.993.206 4.516-1.995l.069.063c.25-.46.556-.729.885-.729M9.25 4.613c-.414 0-.75 1.083-.75 2.419s.336 2.419.75 2.419.75-1.083.75-2.42c0-1.335-.336-2.418-.75-2.418"
}))));
export default SvgChannelAd14;